import {O} from "web-vcore";
import {ignore} from "mobx-sync";
import {SamplesGraphYType} from "../../UI/@Shared/NavBar/SettingsPanel/Transcribe/SamplesGraph.js";
import {store} from "../index.js";
import {AudioSettingsState} from "./settings/audio.js";
import {TranscribeSettingsState} from "./settings/transcribe.js";
import {VRSettingsState} from "./settings/vr.js";

export enum SettingsTab {
	general = "general",
	audio = "audio",
	transcribe = "transcribe",
	vr = "vr",
	more = "more",
}

export enum DragDirection {
	leftToRight = "leftToRight",
	rightToLeft = "rightToLeft",
	either = "either",
}

export enum ConfigChangeDuringSession {
	block = "block",
	allow = "allow",
	//allowAndReapply = "allowAndReapply",
}

export function ParseProviderListFromProvidersStr(providersStr: string|n) {
	if (providersStr == null) return [];
	return providersStr.split(",").map(a=>a.trim()).filter(a=>a.length > 0);
}

export class SettingsState {

	@O accessor tab = SettingsTab.general;

	@O accessor audio = new AudioSettingsState();
	@O accessor transcribe = new TranscribeSettingsState();
	@O accessor vr = new VRSettingsState();
	// more... (conceptual "panels"/setting-groups, that are too small to warrant their own UI panel)
	@O accessor more_subpanel = MoreSettingsSubpanel.web;
	@O accessor web = new WebSettingsState();
	//@O info = new InfoSettingsState();

	@O accessor lockOverlay_dragDirection = DragDirection.either;
	@O accessor configChangeDuringSession = ConfigChangeDuringSession.block;

	@O accessor appStartupScriptTag = null as any;
	@O accessor lightTagForReset = null as any;
	@O accessor lightReapplyDelays = [] as number[];
	@O accessor sequence_itemWait = 1;
	@O accessor keyHoldDuration = 1;
	// on my device, the actual key-repeat threshold was *about* .125s, but I'll default it to .2s to be safe
	// 2025-11-18: Noticed KeyHold and Key triggers both firing from the same key-hold, at .15s; at .6s, mostly fixed but not fully; at .7s, seems fully fixed
	@O accessor keyRepeatThreshold = .7;
	@O accessor maxSampleTimeDrift = .5;
	@O accessor testSegmentStartBuffer = 1;
	@O accessor fakeSampleGeneratorSeed = -1;
	@O accessor elevenLabsAPIKey = null as string|n;

	// llm api's
	@O accessor llm_mainAPI = LLMApi.openRouter;
	@O accessor openRouterAPIKey = null as string|n;
	@O accessor openRouterModel = "claude"
	@O accessor openRouterProviders = "";
	@O accessor openRouter_blockTrainingAndRetention = true;
	@O accessor anthropicAPIKey = null as string|n;
	@O accessor anthropicModel = "claude-sonnet-4-6";

	@O accessor allowTextureMipmaps = true;

	@O accessor autoRestartService = true;
	@O accessor sessionJSWake_enabled = false;
	@O accessor sessionJSWake_interval = 1; // in seconds // probably todo = remove this, since we fixed root problem (using fullWakeJS_repeatTimer)

	// android-specific
	// ==========

	@O accessor android_devServerURL = "https://192.168.0.X:4101/?db=prod";
	@O accessor android_showNavBar = false;
}

export enum MoreSettingsSubpanel {
	web = "web",
	info = "info",
	services = "services",
	data = "data",
}

export class WebSettingsState {
	@O accessor fetchSuffix = "";
}
/*export class InfoSettingsState {
	@O accessor placeholder = true;
}*/

export enum LLMApi {
	openRouter = "openRouter",
	anthropic = "anthropic",
}